module.exports = __webpack_public_path__ + "img/conteudos_casas_construcao_16.06d076fb.png";